import reactLogo from "../assets/logoreact.png";
import tmdbLogo from "../assets/logotmdb.svg";
import "./About.css";
import AdRow from "../components/AdRow";

function About() {
  return (
    <div className="about">
      <h1 className="ch1" id="ah1">
        {" "}
        About uFlix
      </h1>
      <hr id="aline1" />
      <br />
      <AdRow />
      <br />
      <h2 className="ah2">References</h2>
      <div className="arefcon">
      <div className="aref">
        This Website is Made with API from :
        <div className='source'>
        <img src={tmdbLogo} className="sourcelogo" />
        {/* The Movie Database (TMDB) */}
        </div>
        <br />
        This Website is Made with JS Library from :
        <div className='source'>
        <img src={reactLogo} className="sourcelogo2" />
      </div>
      </div>
      </div>
    </div>
  );
}

export default About;
